import { useRouter } from 'next/router';
import useLanguageSetting from '@/hooks/useLanguageSetting';
import { resolveLanguageSettingOptions } from '@/constant/language';

/**
 * 라우트 단위로 사용자 언어 설정을 i18n 에 적용한다.
 *
 * `_app` 최상위에 한 번만 마운트되므로, 대상 라우트(`constant/language` 의
 * `LANGUAGE_SYNCED_ROUTES`)에 속하면 진입 경로(주소 직접 입력 / 새로고침 /
 * 알림 링크 / 화면 내 이동 / 언어 변경 저장 후 reload)와 무관하게 동일하게 동작한다.
 * 페이지가 각자 훅을 부르지 않아 새 페이지에서 누락될 여지가 없다.
 *
 * 라우트가 바뀔 때마다 해당 라우트의 언어를 다시 적용한다
 * (`useLanguageSetting` 이 `pathname` 을 deps 에 넣는 이유). 그래서 `ErrorPage` 처럼
 * 화면 언어를 바꿔놓고 안 되돌리는 컴포넌트를 거쳐도 화면을 옮기면 정리된다.
 *
 * 렌더 결과가 없는 effect 전용 컴포넌트 — jotai `Provider` 안(MyInfoState 접근)이자
 * `I18nextProvider` 안에 두어야 한다.
 */
const LanguageSync = () => {
  const { pathname } = useRouter();
  const options = resolveLanguageSettingOptions(pathname);

  useLanguageSetting({
    isZhEn: options?.isZhEn ?? false,
    rnLanguageIsFirst: options?.rnLanguageIsFirst ?? false,
    // 미등록 라우트는 언어를 건드리지 않는다 — 이전 화면의 언어가 그대로 이어진다
    enabled: Boolean(options),
    // ko 되돌리기는 라우트 소유자인 여기서만. RN 대상 라우트는 앞 화면의 `?lang=en` 이
    // 이어져야 하므로 제외한다(`/m/index?lang=en` → `/m/document` 처럼 쿼리가 빠진 이동).
    revertToKo: options ? !options.rnLanguageIsFirst : false,
  });

  return null;
};

export default LanguageSync;
